import { computed } from "vue";
import { useRoute } from "vue-router";

const formatRouteName = (name: string) =>
  name
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .toLowerCase();

export const useAnalyticsRouteSource = () => {
  const route = useRoute();

  const analyticsRouteSource = computed(() => ({
    source_route: formatRouteName(String(route.name ?? "unknown")),
    source_path: route.path,
  }));

  return { analyticsRouteSource };
};
